import { globalizationPath as composeFromMarketAndLang } from '@rcg/ui-react';
import { marketPathVar } from '../../operations/localState/reactiveVariables';

/**
 * Drop-in replacement for ui-react's globalizationPath, same signature so call sites only change
 * their import. ui-react composes `/{market}/{lang}` and masks only `usa`/`int` with English, which
 * matches Royal but not Celebrity: its slugs are two letters, its default market `us` is not on the
 * mask list, and it omits the language when that language is the market default. g11n publishes the
 * answer as market.marketPath, so it is used verbatim. Identical to the composed value for Royal.
 *
 * Falls back to ui-react's composition while marketPath is empty — the g11n killswitch being off.
 */
// g11n answers with an absolute URL for markets whose site lives on another domain — Celebrity's
// `int` market resolves that way for FRA, DEU, ITA and ESP, pointing at the local franchise. Only
// a value that can prefix one of our routes is usable as one; anything else means no prefix, since
// this app is served from the current origin whatever g11n says about the market's own site.
const usableAsPrefix = (marketPath) => marketPath.startsWith('/') && !marketPath.startsWith('//');

export const globalizationPath = (market, lang, subPath, page) => {
  const path = subPath || '';
  const marketPath = marketPathVar();
  if (!marketPath) return composeFromMarketAndLang(market, lang, path, page);
  // Concatenating an off-site value would turn every route into an external link, and App.js
  // navigates to what it builds — which walked the guest out of the app mid-booking.
  if (!usableAsPrefix(marketPath)) return path;
  // '/' for a brand's default market — concatenating it would double the slash.
  return `${marketPath === '/' ? '' : marketPath}${path}`;
};

export default globalizationPath;
